module.exports = __webpack_public_path__ + "static/media/hangman13.06d9fddc.svg";